var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.prices.length)?_c('v-container',{staticClass:"prices"},_vm._l((_vm.prices),function(price,i){return _c('row',_vm._b({key:i},'row',price,false))}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }